import { render, staticRenderFns } from "./JoeyMessageGroup.vue?vue&type=template&id=fcea853c"
import script from "./JoeyMessageGroup.vue?vue&type=script&lang=ts"
export * from "./JoeyMessageGroup.vue?vue&type=script&lang=ts"
import style0 from "./JoeyMessageGroup.vue?vue&type=style&index=0&id=fcea853c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports